/**
 * Module errors.
 *
 * @module
 */
/** The provided gas schedule bytes are empty or invalid */
export const EINVALID_GAS_SCHEDULE = {
  code: 1,
  name: "EINVALID_GAS_SCHEDULE",
  doc: "The provided gas schedule bytes are empty or invalid",
} as const;
